<template>
  <div class="narrow-cart">
    <div class="items">
      <div class="cart-item" v-for="(line, index) in cartLinesWithData" :key="index">
        <div class="left-column">
          <div class="title">{{ line.dish.post_title }}, <span class="size">{{ line.dish.size }}</span></div>
          <div class="price-cont">
            <div class="price" v-html="priceInnerHTML(line)"></div>
            <div class="crossed-price" v-if="+line.dish.discount" v-html="crossedPriceInnerHTML(line)"></div>
          </div>
        </div>
        <div class="right-column">
          <div class="remove-button" @click="removeLineFromCart(line.id)"><svg-inline :src="require('@/assets/icons/remove.svg')" /></div>
          <quantity-selector
            class="small"
            :amount="line.quantity"
            @clickMinus="removeFromCart(line.id)"
            @clickPlus="addToCart(line.id)"
          />
        </div>
      </div>
      <div class="cart-item" v-for="(dish, promotionId) in promotionsGifts" :key="promotionId">
        <div class="left-column">
          <div class="title">{{ dish.post_title }}, <span class="size">{{ dish.size }}</span></div>

        </div>
        <div class="right-column gift">
<!--          <div class="remove-button" @click="removeLineFromCart(line.id)"><svg-inline :src="require('@/assets/icons/remove.svg')" /></div>-->
<!--          <quantity-selector-->
<!--            class="small"-->
<!--            :amount="line.quantity"-->
<!--            @clickMinus="removeFromCart(line.id)"-->
<!--            @clickPlus="addToCart(line.id)"-->
<!--          />-->
          <div class="price-cont">
            <div class="gift-icon"><svg-inline :src="require('@/assets/icons/gift.svg')" /></div>
            <div class="crossed-price">{{ +dish.price | money }}&nbsp;<rub /></div>
          </div>
        </div>


<!--        <div class="image" :style="{'background-image': `url('${image(dish.image)}')`}" :class="{ 'use-contain': dish.image_use_contain }"></div>-->
<!--        <div class="info">-->
<!--          <div class="title">{{ dish.post_title }}, <span class="size">{{ dish.size }}</span></div>-->
<!--          <div class="desc">{{ dish.desc }}</div>-->
<!--        </div>-->
<!--        <div class="quantity-selector-mock"></div>-->
<!--        <div class="price-cont">-->
<!--          <div class="gift-icon"><svg-inline :src="require('@/assets/icons/gift.svg')" /></div>-->
<!--          <div class="crossed-price">{{ +dish.price | money }} <rub /></div>-->
<!--        </div>-->
<!--        <div class="remove-button-mock"></div>-->
      </div>
    </div>
    <div class="thin-line"></div>
    <div class="delivery-line">
      <template v-if="totalSum >= 1400">
        <div class="label">Доставка:</div>
        <div class="price">бесплатно</div>
      </template>
      <template v-else-if="totalSum >= 1200">
        <div class="label">Доставка:</div>
        <div class="price">бесплатно для <router-link :to="{ name: 'Conditions' }">зон 1 и 2</router-link></div>
      </template>
      <template v-else-if="totalSum >= 800">
        <div class="label">Доставка:</div>
        <div class="price">бесплатно для <router-link :to="{ name: 'Conditions' }">зоны 1</router-link></div>
      </template>
      <template v-else>
        <div class="message">Минимальная сумма заказа составляет 800 <rub />, пожалуйста, добавьте что-то ещё.</div>
      </template>
    </div>
    <div class="total-line">
      <div class="label">Сумма заказа:</div>
      <div class="crossed-price" v-if="totalSumBeforeDiscount !== totalSum">{{ totalSumBeforeDiscount | money }} <rub /></div>
      <div class="price">{{ totalSum | money }} <rub /></div>
    </div>
    <div class="gift-line" v-if="!isSmartphone && totalSum >= 800">Перейдите к оформлению, чтобы выбрать подарок</div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import QuantitySelector from '/src/components/QuantitySelector'

  export default {
    name: 'NarrowCart',
    components: {
      QuantitySelector
    },
    props: {
      promotionsGifts: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    methods: {
      ...mapActions({
        addToCart: 'cart/addToCart',
        removeFromCart: 'cart/removeFromCart',
        removeLineFromCart: 'cart/removeLineFromCart'
      }),
      priceInnerHTML (line) {
        return this.moneyFormat((+line.dish.price - +line.dish.discount) * line.quantity) + '&nbsp;₽'
      },
      crossedPriceInnerHTML (line) {
        return this.moneyFormat(+line.dish.price * line.quantity) + '&nbsp;₽'
      }
    },
    computed: {
      ...mapGetters({
        totalSum: 'cart/totalSum',
        totalSumBeforeDiscount: 'cart/totalSumBeforeDiscount',
        cartLinesWithData: 'cart/cartLinesWithData'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/NarrowCart.vue